// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + (chunkId === 14 ? "bh-helper-instance" : chunkId) + "-legacy." + {"14":"81fd799d","183":"320d9e58","266":"9ec06560","268":"3988dda4","561":"9479996e","607":"5ac21b4a","786":"00203110"}[chunkId] + ".js";
};